export const data = [
  {
    "S. No. ": 1,
    Geo: "Canada",
    "Audience Segments": "Language",
    "Sub Segments": "Hindi",
    Reach: 3023450,
    Desktop: 5.0,
    Mobile: 85,
    SmartTV: 10.0,
    Banner: 89,
    Video: 11,
    Metro: 76.0,
    "Non Metro": 24.0,
    Male: 56,
    Female: 44,
    "Display CPM": 7.0,
    "Video CPM": 15,
    "CTV CPM": 30,
  },
  {
    "S. No. ": 3,
    Geo: "Canada",
    "Audience Segments": "Language",
    "Sub Segments": "Arabic",
    Reach: 5745454,
    Desktop: 6.666666667,
    Mobile: 80,
    SmartTV: 13.33333333,
    Banner: 77,
    Video: 23,
    Metro: 73.0,
    "Non Metro": 27.0,
    Male: 64,
    Female: 36,
    "Display CPM": 7.0,
    "Video CPM": 15,
    "CTV CPM": 30,
  },
  {
    "S. No. ": 2,
    Geo: "Canada",
    "Audience Segments": "Language",
    "Sub Segments": "Chinese",
    Reach: 4228000,
    Desktop: 7.333333333,
    Mobile: 78,
    SmartTV: 14.66666667,
    Banner: 56,
    Video: 44,
    Metro: 75.0,
    "Non Metro": 25.0,
    Male: 76,
    Female: 24,
    "Display CPM": 7.0,
    "Video CPM": 15,
    "CTV CPM": 30,
  },
  {
    "S. No. ": 50,
    Geo: "GCC",
    "Audience Segments": "Multicultural & Expat Communities",
    "Sub Segments": "Asian & Chinese Expats",
    Reach: 5672132,
    Desktop: 7.0,
    Mobile: 79,
    SmartTV: 14.0,
    Banner: 82,
    Video: 18,
    Metro: null,
    "Non Metro": null,
    Male: 58,
    Female: 42,
    "Display CPM": 4.0,
    "Video CPM": 6,
    "CTV CPM": 12,
  },
  {
    "S. No. ": 47,
    Geo: "GCC",
    "Audience Segments": "Luxury & High-Net-Worth Individuals (HNWIs)",
    "Sub Segments": "Elite Travel Enthusiasts ",
    Reach: 5567906,
    Desktop: 4.0,
    Mobile: 88,
    SmartTV: 8.0,
    Banner: 87,
    Video: 13,
    Metro: null,
    "Non Metro": null,
    Male: 58,
    Female: 42,
    "Display CPM": 4.0,
    "Video CPM": 6,
    "CTV CPM": 12,
  },
  {
    "S. No. ": 48,
    Geo: "GCC",
    "Audience Segments": "Luxury & High-Net-Worth Individuals (HNWIs)",
    "Sub Segments": "Food",
    Reach: 4785432,
    Desktop: 6.333333333,
    Mobile: 81,
    SmartTV: 12.66666667,
    Banner: 83,
    Video: 17,
    Metro: null,
    "Non Metro": null,
    Male: 66,
    Female: 34,
    "Display CPM": 4.0,
    "Video CPM": 6,
    "CTV CPM": 12,
  },
  {
    "S. No. ": 46,
    Geo: "GCC",
    "Audience Segments": "Luxury & High-Net-Worth Individuals (HNWIs)",
    "Sub Segments": "Luxury Brand Shoppers",
    Reach: 6456879,
    Desktop: 6.0,
    Mobile: 82,
    SmartTV: 12.0,
    Banner: 88,
    Video: 12,
    Metro: null,
    "Non Metro": null,
    Male: 45,
    Female: 55,
    "Display CPM": 4.0,
    "Video CPM": 6,
    "CTV CPM": 12,
  },
  {
    "S. No. ": 45,
    Geo: "GCC",
    "Audience Segments": "Luxury & High-Net-Worth Individuals (HNWIs)",
    "Sub Segments": "Supercar & Exotic Car Buyers",
    Reach: 5656789,
    Desktop: 8.0,
    Mobile: 76,
    SmartTV: 16.0,
    Banner: 76,
    Video: 24,
    Metro: null,
    "Non Metro": null,
    Male: 93,
    Female: 7,
    "Display CPM": 4.0,
    "Video CPM": 6,
    "CTV CPM": 12,
  },
  {
    "S. No. ": 49,
    Geo: "GCC",
    "Audience Segments": "Multicultural & Expat Communities",
    "Sub Segments": "Western Expats",
    Reach: 6576909,
    Desktop: 8.0,
    Mobile: 76,
    SmartTV: 16.0,
    Banner: 79,
    Video: 21,
    Metro: null,
    "Non Metro": null,
    Male: 67,
    Female: 33,
    "Display CPM": 4.0,
    "Video CPM": 6,
    "CTV CPM": 12,
  },
  {
    "S. No. ": 23,
    Geo: "India",
    "Audience Segments": "Automobile",
    "Sub Segments": "Auto-Enthusiast",
    Reach: 16078906,
    Desktop: 11.66666667,
    Mobile: 65,
    SmartTV: 23.33333333,
    Banner: 54,
    Video: 46,
    Metro: 66.0,
    "Non Metro": 34.0,
    Male: 88,
    Female: 12,
    "Display CPM": 1.5,
    "Video CPM": 3,
    "CTV CPM": 10,
  },
  {
    "S. No. ": 19,
    Geo: "India",
    "Audience Segments": "Women",
    "Sub Segments": "Beauty",
    Reach: 14237890,
    Desktop: 5.666666667,
    Mobile: 83,
    SmartTV: 11.33333333,
    Banner: 56,
    Video: 44,
    Metro: 58.0,
    "Non Metro": 42.0,
    Male: 0,
    Female: 100,
    "Display CPM": 1.5,
    "Video CPM": 3,
    "CTV CPM": 10,
  },
  {
    "S. No. ": 18,
    Geo: "India",
    "Audience Segments": "Sport",
    "Sub Segments": "Cricket - IPL",
    Reach: 27090978,
    Desktop: 7.666666667,
    Mobile: 77,
    SmartTV: 15.33333333,
    Banner: 40,
    Video: 60,
    Metro: 59.0,
    "Non Metro": 41.0,
    Male: 75,
    Female: 25,
    "Display CPM": 1.5,
    "Video CPM": 3,
    "CTV CPM": 10,
  },
  {
    "S. No. ": 14,
    Geo: "India",
    "Audience Segments": "Family and Parenting",
    "Sub Segments": "Family and Parenting",
    Reach: 13202049,
    Desktop: 7.666666667,
    Mobile: 77,
    SmartTV: 15.33333333,
    Banner: 67,
    Video: 33,
    Metro: 53.0,
    "Non Metro": 47.0,
    Male: 43,
    Female: 57,
    "Display CPM": 1.5,
    "Video CPM": 3,
    "CTV CPM": 10,
  },
  {
    "S. No. ": 6,
    Geo: "India",
    "Audience Segments": "Women",
    "Sub Segments": "Fashion",
    Reach: 14034000,
    Desktop: 8.0,
    Mobile: 76,
    SmartTV: 16.0,
    Banner: 53,
    Video: 47,
    Metro: 69.0,
    "Non Metro": 31.0,
    Male: 0,
    Female: 100,
    "Display CPM": 1.5,
    "Video CPM": 3,
    "CTV CPM": 10,
  },
  {
    "S. No. ": 17,
    Geo: "India",
    "Audience Segments": "Health & Wellness",
    "Sub Segments": "Health & Fitness",
    Reach: 22098909,
    Desktop: 10.0,
    Mobile: 70,
    SmartTV: 20.0,
    Banner: 43,
    Video: 57,
    Metro: 58.0,
    "Non Metro": 42.0,
    Male: 58,
    Female: 42,
    "Display CPM": 1.5,
    "Video CPM": 3,
    "CTV CPM": 10,
  },
  {
    "S. No. ": 61,
    Geo: "India",
    "Audience Segments": "Performance",
    "Sub Segments": "High CTR",
    Reach: 20674578,
    Desktop: 6.333333333,
    Mobile: 81,
    SmartTV: 12.66666667,
    Banner: 72,
    Video: 28,
    Metro: 49.0,
    "Non Metro": 51.0,
    Male: 55,
    Female: 45,
    "Display CPM": 1.5,
    "Video CPM": 3,
    "CTV CPM": 10,
  },
  {
    "S. No. ": 62,
    Geo: "India",
    "Audience Segments": "Performance",
    "Sub Segments": "High VCR",
    Reach: 22756598,
    Desktop: 7.666666667,
    Mobile: 77,
    SmartTV: 15.33333333,
    Banner: 65,
    Video: 35,
    Metro: 56.0,
    "Non Metro": 44.0,
    Male: 51,
    Female: 49,
    "Display CPM": 0.0,
    "Video CPM": 3,
    "CTV CPM": 10,
  },
  {
    "S. No. ": 63,
    Geo: "India",
    "Audience Segments": "Performance",
    "Sub Segments": "High Viewability",
    Reach: 21765467,
    Desktop: 6.0,
    Mobile: 82,
    SmartTV: 12.0,
    Banner: 61,
    Video: 39,
    Metro: 61.0,
    "Non Metro": 39.0,
    Male: 44,
    Female: 56,
    "Display CPM": 1.5,
    "Video CPM": 3,
    "CTV CPM": 10,
  },
  {
    "S. No. ": 15,
    Geo: "India",
    "Audience Segments": "Tech",
    "Sub Segments": "Mobile Enthusiasts",
    Reach: 19079867,
    Desktop: 9.0,
    Mobile: 73,
    SmartTV: 18.0,
    Banner: 41,
    Video: 59,
    Metro: 55.0,
    "Non Metro": 45.0,
    Male: 77,
    Female: 23,
    "Display CPM": 1.5,
    "Video CPM": 3,
    "CTV CPM": 10,
  },
  {
    "S. No. ": 5,
    Geo: "India",
    "Audience Segments": "Women",
    "Sub Segments": "Moms",
    Reach: 12980070,
    Desktop: 7.666666667,
    Mobile: 77,
    SmartTV: 15.33333333,
    Banner: 58,
    Video: 42,
    Metro: 70.0,
    "Non Metro": 30.0,
    Male: 0,
    Female: 100,
    "Display CPM": 1.5,
    "Video CPM": 3,
    "CTV CPM": 10,
  },
  {
    "S. No. ": 22,
    Geo: "India",
    "Audience Segments": "Music lovers",
    "Sub Segments": "Music lovers",
    Reach: 14980987,
    Desktop: 8.333333333,
    Mobile: 75,
    SmartTV: 16.66666667,
    Banner: 44,
    Video: 56,
    Metro: 63.0,
    "Non Metro": 37.0,
    Male: 58,
    Female: 42,
    "Display CPM": 1.5,
    "Video CPM": 3,
    "CTV CPM": 10,
  },
  {
    "S. No. ": 16,
    Geo: "India",
    "Audience Segments": "Tech",
    "Sub Segments": "Social Media Enthusiasts",
    Reach: 23876580,
    Desktop: 9.333333333,
    Mobile: 72,
    SmartTV: 18.66666667,
    Banner: 42,
    Video: 58,
    Metro: 58.0,
    "Non Metro": 42.0,
    Male: 42,
    Female: 58,
    "Display CPM": 1.5,
    "Video CPM": 3,
    "CTV CPM": 10,
  },
  {
    "S. No. ": 12,
    Geo: "India",
    "Audience Segments": "Travel & Experience Seekers",
    "Sub Segments": "Travel Enthusiast",
    Reach: 12649070,
    Desktop: 8.0,
    Mobile: 76,
    SmartTV: 16.0,
    Banner: 63,
    Video: 37,
    Metro: 56.0,
    "Non Metro": 44.0,
    Male: 66,
    Female: 34,
    "Display CPM": 1.5,
    "Video CPM": 3,
    "CTV CPM": 10,
  },
  {
    "S. No. ": 59,
    Geo: "Indonesia",
    "Audience Segments": "Sports & Fitness Fans",
    "Sub Segments": "Badminton Enthusiasts",
    Reach: 2546784,
    Desktop: 8.666666667,
    Mobile: 74,
    SmartTV: 17.33333333,
    Banner: 78,
    Video: 22,
    Metro: null,
    "Non Metro": null,
    Male: 61,
    Female: 39,
    "Display CPM": 2.0,
    "Video CPM": 4,
    "CTV CPM": 8,
  },
  {
    "S. No. ": 60,
    Geo: "Indonesia",
    "Audience Segments": "Sports & Fitness Fans",
    "Sub Segments": "Cycling & Running Communities ",
    Reach: 1765678,
    Desktop: 9.333333333,
    Mobile: 72,
    SmartTV: 18.66666667,
    Banner: 79,
    Video: 21,
    Metro: null,
    "Non Metro": null,
    Male: 69,
    Female: 31,
    "Display CPM": 2.0,
    "Video CPM": 4,
    "CTV CPM": 8,
  },
  {
    "S. No. ": 58,
    Geo: "Indonesia",
    "Audience Segments": "Sports & Fitness Fans",
    "Sub Segments": "Football Fanatics",
    Reach: 2876705,
    Desktop: 7.666666667,
    Mobile: 77,
    SmartTV: 15.33333333,
    Banner: 85,
    Video: 15,
    Metro: null,
    "Non Metro": null,
    Male: 77,
    Female: 23,
    "Display CPM": 2.0,
    "Video CPM": 4,
    "CTV CPM": 8,
  },
  {
    "S. No. ": 56,
    Geo: "Indonesia",
    "Audience Segments": "Entertainment & Lifestyle Consumers",
    "Sub Segments": "Influencer & Vlogger Followers ",
    Reach: 5656890,
    Desktop: 7.333333333,
    Mobile: 78,
    SmartTV: 14.66666667,
    Banner: 84,
    Video: 16,
    Metro: null,
    "Non Metro": null,
    Male: 41,
    Female: 59,
    "Display CPM": 3.0,
    "Video CPM": 5,
    "CTV CPM": 10,
  },
  {
    "S. No. ": 54,
    Geo: "Indonesia",
    "Audience Segments": "Entertainment & Lifestyle Consumers",
    "Sub Segments": "K-Drama & K-Pop Fans",
    Reach: 6978907,
    Desktop: 6.333333333,
    Mobile: 81,
    SmartTV: 12.66666667,
    Banner: 86,
    Video: 14,
    Metro: null,
    "Non Metro": null,
    Male: 43,
    Female: 57,
    "Display CPM": 3.0,
    "Video CPM": 5,
    "CTV CPM": 10,
  },
  {
    "S. No. ": 52,
    Geo: "Indonesia",
    "Audience Segments": "E-Commerce & Online Shopping Consumers",
    "Sub Segments": "Luxury Brand Buyers ",
    Reach: 1897890,
    Desktop: 6.0,
    Mobile: 82,
    SmartTV: 12.0,
    Banner: 88,
    Video: 12,
    Metro: null,
    "Non Metro": null,
    Male: 48,
    Female: 52,
    "Display CPM": 3.0,
    "Video CPM": 5,
    "CTV CPM": 10,
  },
  {
    "S. No. ": 33,
    Geo: "US",
    "Audience Segments": "HHI",
    "Sub Segments": "120k+",
    Reach: 7068790,
    Desktop: 4.0,
    Mobile: 88,
    SmartTV: 8.0,
    Banner: 71,
    Video: 29,
    Metro: null,
    "Non Metro": null,
    Male: 79,
    Female: 21,
    "Display CPM": 8.0,
    "Video CPM": 24,
    "CTV CPM": 40,
  },
  {
    "S. No. ": 32,
    Geo: "US",
    "Audience Segments": "HHI",
    "Sub Segments": "75k-120k",
    Reach: 219780780,
    Desktop: 7.0,
    Mobile: 79,
    SmartTV: 14.0,
    Banner: 72,
    Video: 28,
    Metro: null,
    "Non Metro": null,
    Male: 81,
    Female: 19,
    "Display CPM": 8.0,
    "Video CPM": 20,
    "CTV CPM": 40,
  },
  {
    "S. No. ": 27,
    Geo: "US",
    "Audience Segments": "Ethnicity",
    "Sub Segments": "African American",
    Reach: 67546750,
    Desktop: 6.0,
    Mobile: 82,
    SmartTV: 12.0,
    Banner: 54,
    Video: 46,
    Metro: null,
    "Non Metro": null,
    Male: 65,
    Female: 35,
    "Display CPM": 8.0,
    "Video CPM": 18,
    "CTV CPM": 40,
  },
  {
    "S. No. ": 28,
    Geo: "US",
    "Audience Segments": "Ethnicity",
    "Sub Segments": "Asian Chinese",
    Reach: 378680,
    Desktop: 5.0,
    Mobile: 85,
    SmartTV: 10.0,
    Banner: 65,
    Video: 35,
    Metro: null,
    "Non Metro": null,
    Male: 58,
    Female: 42,
    "Display CPM": 8.0,
    "Video CPM": 18,
    "CTV CPM": 40,
  },
  {
    "S. No. ": 29,
    Geo: "US",
    "Audience Segments": "Ethnicity",
    "Sub Segments": "Asian Indian",
    Reach: 489070,
    Desktop: 7.333333333,
    Mobile: 78,
    SmartTV: 14.66666667,
    Banner: 66,
    Video: 34,
    Metro: null,
    "Non Metro": null,
    Male: 62,
    Female: 38,
    "Display CPM": 8.0,
    "Video CPM": 18,
    "CTV CPM": 40,
  },
  {
    "S. No. ": 38,
    Geo: "US",
    "Audience Segments": "Automobile",
    "Sub Segments": "Auto Enthusiast",
    Reach: 40897861,
    Desktop: 3.666666667,
    Mobile: 89,
    SmartTV: 7.333333333,
    Banner: 65,
    Video: 35,
    Metro: null,
    "Non Metro": null,
    Male: 72,
    Female: 28,
    "Display CPM": 8.0,
    "Video CPM": 18,
    "CTV CPM": 40,
  },
  {
    "S. No. ": 35,
    Geo: "US",
    "Audience Segments": "Shopping",
    "Sub Segments": "Black Friday",
    Reach: 556890,
    Desktop: 8.666666667,
    Mobile: 74,
    SmartTV: 17.33333333,
    Banner: 88,
    Video: 12,
    Metro: null,
    "Non Metro": null,
    Male: 47,
    Female: 53,
    "Display CPM": 8.0,
    "Video CPM": 20,
    "CTV CPM": 40,
  },
  {
    "S. No. ": 37,
    Geo: "US",
    "Audience Segments": "Auto Enthusiasts",
    "Sub Segments": "EV & Sustainable Car Buyers",
    Reach: 2076578,
    Desktop: 6.0,
    Mobile: 82,
    SmartTV: 12.0,
    Banner: 83,
    Video: 17,
    Metro: null,
    "Non Metro": null,
    Male: 76,
    Female: 24,
    "Display CPM": 8.0,
    "Video CPM": 22,
    "CTV CPM": 40,
  },
  {
    "S. No. ": 41,
    Geo: "US",
    "Audience Segments": "Sports & Gaming Fans",
    "Sub Segments": "Fantasy Sports & Sports Betters",
    Reach: 78967890,
    Desktop: 5.0,
    Mobile: 85,
    SmartTV: 10.0,
    Banner: 61,
    Video: 39,
    Metro: null,
    "Non Metro": null,
    Male: 92,
    Female: 8,
    "Display CPM": 8.0,
    "Video CPM": 20,
    "CTV CPM": 40,
  },
  {
    "S. No. ": 26,
    Geo: "US",
    "Audience Segments": "Ethnicity",
    "Sub Segments": "Hispanic",
    Reach: 200876890,
    Desktop: 10.33333333,
    Mobile: 69,
    SmartTV: 20.66666667,
    Banner: 73,
    Video: 27,
    Metro: null,
    "Non Metro": null,
    Male: 77,
    Female: 23,
    "Display CPM": 8.0,
    "Video CPM": 16,
    "CTV CPM": 40,
  },
  {
    "S. No. ": 39,
    Geo: "US",
    "Audience Segments": "Auto Enthusiasts",
    "Sub Segments": "Luxury Car Buyers",
    Reach: 4786723,
    Desktop: 7.666666667,
    Mobile: 77,
    SmartTV: 15.33333333,
    Banner: 67,
    Video: 33,
    Metro: null,
    "Non Metro": null,
    Male: 69,
    Female: 31,
    "Display CPM": 8.0,
    "Video CPM": 20,
    "CTV CPM": 40,
  },
  {
    "S. No. ": 40,
    Geo: "US",
    "Audience Segments": "Sports & Gaming Fans",
    "Sub Segments": "MLB",
    Reach: 65832098,
    Desktop: 8.0,
    Mobile: 76,
    SmartTV: 16.0,
    Banner: 63,
    Video: 37,
    Metro: null,
    "Non Metro": null,
    Male: 88,
    Female: 12,
    "Display CPM": 8.0,
    "Video CPM": 20,
    "CTV CPM": 40,
  },
  {
    "S. No. ": 42,
    Geo: "US",
    "Audience Segments": "Sports & Gaming Fans",
    "Sub Segments": "NBA",
    Reach: 154565879,
    Desktop: 5.333333333,
    Mobile: 84,
    SmartTV: 10.66666667,
    Banner: 59,
    Video: 41,
    Metro: null,
    "Non Metro": null,
    Male: 78,
    Female: 22,
    "Display CPM": 8.0,
    "Video CPM": 20,
    "CTV CPM": 40,
  },
  {
    "S. No. ": 44,
    Geo: "US",
    "Audience Segments": "Sports & Gaming Fans",
    "Sub Segments": "NFL",
    Reach: 26756743,
    Desktop: 7.666666667,
    Mobile: 77,
    SmartTV: 15.33333333,
    Banner: 77,
    Video: 23,
    Metro: null,
    "Non Metro": null,
    Male: 79,
    Female: 21,
    "Display CPM": 8.0,
    "Video CPM": 20,
    "CTV CPM": 40,
  },
  {
    "S. No. ": 43,
    Geo: "US",
    "Audience Segments": "Sports & Gaming Fans",
    "Sub Segments": "Pickleball",
    Reach: 6076578,
    Desktop: 4.0,
    Mobile: 88,
    SmartTV: 8.0,
    Banner: 54,
    Video: 46,
    Metro: null,
    "Non Metro": null,
    Male: 49,
    Female: 51,
    "Display CPM": 8.0,
    "Video CPM": 20,
    "CTV CPM": 40,
  },
  {
    "S. No. ": 36,
    Geo: "US",
    "Audience Segments": "Travel",
    "Sub Segments": "Travel Enthusiast",
    Reach: 186780987,
    Desktop: 6.333333333,
    Mobile: 81,
    SmartTV: 12.66666667,
    Banner: 70,
    Video: 30,
    Metro: null,
    "Non Metro": null,
    Male: 44,
    Female: 56,
    "Display CPM": 8.0,
    "Video CPM": 18,
    "CTV CPM": 40,
  },
  {
    "S. No. ": 34,
    Geo: "US",
    "Audience Segments": "Shopping",
    "Sub Segments": "Women Shoppers",
    Reach: 47684650,
    Desktop: 9.333333333,
    Mobile: 72,
    SmartTV: 18.66666667,
    Banner: 82,
    Video: 18,
    Metro: null,
    "Non Metro": null,
    Male: 0,
    Female: 100,
    "Display CPM": 8.0,
    "Video CPM": 20,
    "CTV CPM": 40,
  },
];
